var Handlebars = require('injectify/runtime');
var lodash = require('lodash');
var utils = require('injectify/utils');


/**
 * Inject a view into the Handlebars template
 *
 * {{view "../../path/to/view" param1=var ...}}
 */
Handlebars.registerHelper('view', function () {
    var args = utils.extractArguments(this, lodash.toArray(arguments));
    var options = args.options;
    var hash = args.hash;

    if (options.fn) {
        hash.content = function (opts) {
            opts = _.clone(opts);
            delete opts.content;
            return new Handlebars.SafeString(options.fn(opts, {data: {view: this}}));
        };
    }

    var onRender = function () {
        args.parentView.addRegion(args.name, {
            el: "#"+args.name,
            replaceElement: true
        });
        var region = args.parentView.getRegion(args.name);

        region.show(new args.module(args.hash));
    };

    var onDestroy = function () {
        args.parentView.off('render', onRender);
    };

    args.parentView.once('render', onRender);
    args.parentView.once('destroy', onDestroy);
    return new Handlebars.SafeString("<div id='"+args.name+"'></div>");
});

/**
 * Make possible nesting for injected views
 *
 * Use "view" helper like this
 * {{#view "../../path/to/view" param1=var ...}}...nested content...{{/view}}
 *
 * And then add "content" helper in view's template
 * {{content}}
 */
Handlebars.registerHelper('content', function (options) {

    var view = utils.extractView(this, options.hash, options),
        content = this.content;

    if (content == null && view && view.options.content != null) {
        content = view.options.content;
    }

    if (typeof content === 'function') {
        return content.call(view, options.data.root, {
            data: options.data
        });
    }

    if (content != null) {
        return content;
    }

    return '';
});



//////////////////
// WEBPACK FOOTER
// ../node_modules/df-view-helper/helper.js
// module id = 692
// module chunks = 46 47